/*
 * main.js - seo-admin
 * Copyright (c) CHECK24 Vergleichsportal Reise GmbH 2023.
 *
 * @author     Mark Kotsarev <mark.kotsarev@check24.de>
 * @modified   02.05.23, 14:00
 */

import 'vite/modulepreload-polyfill';
import '../../../assets/frontend/js/tcms_core_helper'; // FireOnVisible
import './navigation/user.js';
import './system/referenceKeys.js';
import './system/deletePrompt.js';
import './system/filter.js';
import './system/form/addButton.js';

/**
 ### Dynamic Imports ###
 **/

// Widgets import
window.fireOnVisible('.tcms-widget-edit', async(elem) => {
    const widgetName = elem.dataset.widgetName;

    if (widgetName && widgetName !== 'unknown') {
        await import('../../../widgets/' + widgetName + '/import.admin.js').catch((err) => {
            console.log(widgetName + ' loading error');
        });
    }
});

// Session Timer
import('./system/sessionTimer.ts');

// Fetch Calls
import('./system/fetchCalls.js');

// Flash Messages
import('./system/flashMessage.js');

// Datepicker
import('./system/tools/datepicker.js');

// TinyMCE
const editorElems = document.querySelectorAll('.tinyMce');

window.fireOnVisible(editorElems, async(elem) => {
    await import('./system/form/editor.js');
});
window.fireOnNode('.tinyMce', async() => {
    await import('./system/form/editor.js');
});

// Pagination
window.fireOnVisible('.tcms-pagination', async(elem) => {
    await import('./navigation/pagination.js');
});

// language select
window.fireOnVisible('.backend-js-form-submit, #contentLanguageSelect, #massoperation-language-id', async(elem) => {
    await import('./system/language/languageSelect.js');
});

// Map
const mapElems = document.querySelectorAll('.js-map-canvas, #map');

window.fireOnVisible(mapElems, async(elem) => {
    await import('./system/map.js');
});

// PasswordStrength
const passStrengthElem = document.querySelector('.passStrength');

window.fireOnVisible(passStrengthElem, async(elem) => {
    await import('./system/user/password_strength.js');
});

// Region Tree
const autoCompleterElems = document.querySelectorAll('.autocompleter');

window.fireOnVisible(autoCompleterElems, async(elem) => {
    await import('./system/autocomplete/autocomplete.js').then(({ initAutoCompleter }) => {
        initAutoCompleter(elem);
    });
});
window.fireOnNode('.autocompleter', async(elem) => {
    await import('./system/autocomplete/autocomplete.js').then(({ initAutoCompleter }) => {
        initAutoCompleter(elem);
    });
});

// Region Tree
const treeElems = document.querySelectorAll('#regionTree');

window.fireOnVisible(treeElems, async(elem) => {
    await import('./actions/regionTree.js');
});

// Content Element
const contentElementNode = document.querySelector('#ContentElementController');

window.fireOnVisible(contentElementNode, async(elem) => {
    await import('./system/form/mass_operation.js');
    await import('./system/form/workersystem.js');
});

// Content Leaf
const contentLeafNode = document.querySelector('#ContentLeafController');

window.fireOnVisible(contentLeafNode, async(elem) => {
    await import('./system/form/mass_operation.js');
    await import('./system/form/workersystem.js');
});

// WorkerSystem messages
const workerSystemMessageNode = document.querySelector('#WorkerSystemMessageController');

window.fireOnVisible(workerSystemMessageNode, async(elem) => {
    await import('./system/form/mass_operation.js');
    await import('./system/form/workersystem.js');
});

// Template
const templateElems = document.querySelectorAll('.tcms-template-widgets');

window.fireOnVisible(templateElems, async(elem) => {
    await import('./actions/template.js').then(({ WidgetDroplet }) => {
        const wdl = new WidgetDroplet();

        wdl.init();
    });
});

const viewCountElem = document.querySelector('#viewCount');

window.fireOnVisible(viewCountElem, async() => {
    await import('./actions/viewCount.js');
});

// Picture
const pictureElems = document.querySelectorAll('#pictureController');

window.fireOnVisible(pictureElems, async(elem) => {
    await import('./actions/picture.js');
});

// Search form processes
const searchFormProcess = document.querySelectorAll('#searchboxes');

window.fireOnVisible(searchFormProcess, (elem) => {
    import(/* webpackChunkName: "actionSearchFormProcess" */ './actions/searchFormProcess.js');
});

// Hotel Data Changes
const hotelDataChangesElems = document.querySelectorAll('#HotelDataSuggestion');

window.fireOnVisible(hotelDataChangesElems, async(elem) => {
    await import('./actions/hotelDataChanges.js');
    await import('./system/form/mass_operation.js');
});

// Plugins Action
const papElems = document.querySelectorAll('#pluginsActionPage');

window.fireOnVisible(papElems, async(elem) => {
    await import('./system/pluginsUsage.js');
});

// Form Category
window.fireOnVisible('.category-selection-main', async(node) => {
    await import('./system/formCategory.js').then(({ initializeCategorySelection }) => {
        initializeCategorySelection();
    });
});
window.fireOnNode('.category-selection-main', async(node) => {
    await import('./system/formCategory.js').then(({ initializeCategorySelection }) => {
        initializeCategorySelection(node);
    });
});

// Initialize all Tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');

window.fireOnVisible(tooltipTriggerList, async(toolTipTriggerElem) => {
    await import('bootstrap').then(({ Tooltip }) => {
        new Tooltip(toolTipTriggerElem);
    });
});

// Input Switches Checkbox
const checkboxSwitchesElems = document.querySelectorAll('.js-checkbox-switch');

window.fireOnVisible(checkboxSwitchesElems, async(elem) => {
    await import('./system/checkboxSwitch.js');
});

// Input Switches Checkbox
const rewriteController = document.querySelector('#RewriteController');

window.fireOnVisible(rewriteController, async(elem) => {
    await import('./system/language/rewriteToggle.js');
});

// Monaco Editor
const monacoEditor = document.getElementById('monacoEditorContainer');

window.fireOnVisible(monacoEditor, async(elem) => {
    await import('./system/tools/monaco.editor.js');
});
